{
  "version": "2.0",
  "metadata": {
    "apiVersion": "2018-01-04",
    "endpointPrefix": "ram",
    "jsonVersion": "1.1",
    "protocol": "rest-json",
    "serviceAbbreviation": "RAM",
    "serviceFullName": "AWS Resource Access Manager",
    "serviceId": "RAM",
    "signatureVersion": "v4",
    "uid": "ram-2018-01-04"
  },
  "operations": {
    "AcceptResourceShareInvitation": {
      "http": {
        "requestUri": "/acceptresourceshareinvitation"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareInvitationArn"
        ],
        "members": {
          "resourceShareInvitationArn": {},
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareInvitation": {
            "shape": "S4"
          },
          "clientToken": {}
        }
      }
    },
    "AssociateResourceShare": {
      "http": {
        "requestUri": "/associateresourceshare"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn"
        ],
        "members": {
          "resourceShareArn": {},
          "resourceArns": {
            "shape": "Sd"
          },
          "principals": {
            "shape": "Se"
          },
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareAssociations": {
            "shape": "S7"
          },
          "clientToken": {}
        }
      }
    },
    "CreateResourceShare": {
      "http": {
        "requestUri": "/createresourceshare"
      },
      "input": {
        "type": "structure",
        "required": [
          "name"
        ],
        "members": {
          "name": {},
          "resourceArns": {
            "shape": "Sd"
          },
          "principals": {
            "shape": "Se"
          },
          "tags": {
            "shape": "Sh"
          },
          "allowExternalPrincipals": {
            "type": "boolean"
          },
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShare": {
            "shape": "Sm"
          },
          "clientToken": {}
        }
      }
    },
    "DeleteResourceShare": {
      "http": {
        "method": "DELETE",
        "requestUri": "/deleteresourceshare"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn"
        ],
        "members": {
          "resourceShareArn": {
            "location": "querystring",
            "locationName": "resourceShareArn"
          },
          "clientToken": {
            "location": "querystring",
            "locationName": "clientToken"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "returnValue": {
            "type": "boolean"
          },
          "clientToken": {}
        }
      }
    },
    "DisassociateResourceShare": {
      "http": {
        "requestUri": "/disassociateresourceshare"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn"
        ],
        "members": {
          "resourceShareArn": {},
          "resourceArns": {
            "shape": "Sd"
          },
          "principals": {
            "shape": "Se"
          },
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareAssociations": {
            "shape": "S7"
          },
          "clientToken": {}
        }
      }
    },
    "EnableSharingWithAwsOrganization": {
      "http": {
        "requestUri": "/enablesharingwithawsorganization"
      },
      "input": {
        "type": "structure",
        "members": {}
      },
      "output": {
        "type": "structure",
        "members": {
          "returnValue": {
            "type": "boolean"
          }
        }
      }
    },
    "GetResourcePolicies": {
      "http": {
        "requestUri": "/getresourcepolicies"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArns"
        ],
        "members": {
          "resourceArns": {
            "shape": "Sd"
          },
          "principal": {},
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "policies": {
            "type": "list",
            "member": {}
          },
          "nextToken": {}
        }
      }
    },
    "GetResourceShareAssociations": {
      "http": {
        "requestUri": "/getresourceshareassociations"
      },
      "input": {
        "type": "structure",
        "required": [
          "associationType"
        ],
        "members": {
          "associationType": {},
          "resourceShareArns": {
            "shape": "S10"
          },
          "resourceArn": {},
          "principal": {},
          "associationStatus": {},
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareAssociations": {
            "shape": "S7"
          },
          "nextToken": {}
        }
      }
    },
    "GetResourceShareInvitations": {
      "http": {
        "requestUri": "/getresourceshareinvitations"
      },
      "input": {
        "type": "structure",
        "members": {
          "resourceShareInvitationArns": {
            "type": "list",
            "member": {}
          },
          "resourceShareArns": {
            "shape": "S10"
          },
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareInvitations": {
            "type": "list",
            "member": {
              "shape": "S4"
            }
          },
          "nextToken": {}
        }
      }
    },
    "GetResourceShares": {
      "http": {
        "requestUri": "/getresourceshares"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceOwner"
        ],
        "members": {
          "resourceShareArns": {
            "shape": "S10"
          },
          "resourceShareStatus": {},
          "resourceOwner": {},
          "name": {},
          "tagFilters": {
            "type": "list",
            "member": {
              "type": "structure",
              "members": {
                "tagKey": {},
                "tagValues": {
                  "type": "list",
                  "member": {}
                }
              }
            }
          },
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShares": {
            "type": "list",
            "member": {
              "shape": "Sm"
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListPrincipals": {
      "http": {
        "requestUri": "/listprincipals"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceOwner"
        ],
        "members": {
          "resourceOwner": {},
          "resourceArn": {},
          "principals": {
            "shape": "Se"
          },
          "resourceType": {},
          "resourceShareArns": {
            "shape": "S10"
          },
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "principals": {
            "type": "list",
            "member": {
              "type": "structure",
              "members": {
                "id": {},
                "resourceShareArn": {},
                "creationTime": {
                  "type": "timestamp"
                },
                "lastUpdatedTime": {
                  "type": "timestamp"
                },
                "external": {
                  "type": "boolean"
                }
              }
            }
          },
          "nextToken": {}
        }
      }
    },
    "ListResources": {
      "http": {
        "requestUri": "/listresources"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceOwner"
        ],
        "members": {
          "resourceOwner": {},
          "principal": {},
          "resourceType": {},
          "resourceArns": {
            "shape": "Sd"
          },
          "resourceShareArns": {
            "shape": "S10"
          },
          "nextToken": {},
          "maxResults": {
            "type": "integer"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resources": {
            "type": "list",
            "member": {
              "type": "structure",
              "members": {
                "arn": {},
                "type": {},
                "resourceShareArn": {},
                "status": {},
                "statusMessage": {},
                "creationTime": {
                  "type": "timestamp"
                },
                "lastUpdatedTime": {
                  "type": "timestamp"
                }
              }
            }
          },
          "nextToken": {}
        }
      }
    },
    "RejectResourceShareInvitation": {
      "http": {
        "requestUri": "/rejectresourceshareinvitation"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareInvitationArn"
        ],
        "members": {
          "resourceShareInvitationArn": {},
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShareInvitation": {
            "shape": "S4"
          },
          "clientToken": {}
        }
      }
    },
    "TagResource": {
      "http": {
        "requestUri": "/tagresource"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn",
          "tags"
        ],
        "members": {
          "resourceShareArn": {},
          "tags": {
            "shape": "Sh"
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {}
      }
    },
    "UntagResource": {
      "http": {
        "requestUri": "/untagresource"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn",
          "tagKeys"
        ],
        "members": {
          "resourceShareArn": {},
          "tagKeys": {
            "type": "list",
            "member": {}
          }
        }
      },
      "output": {
        "type": "structure",
        "members": {}
      }
    },
    "UpdateResourceShare": {
      "http": {
        "requestUri": "/updateresourceshare"
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceShareArn"
        ],
        "members": {
          "resourceShareArn": {},
          "name": {},
          "allowExternalPrincipals": {
            "type": "boolean"
          },
          "clientToken": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "resourceShare": {
            "shape": "Sm"
          },
          "clientToken": {}
        }
      }
    }
  },
  "shapes": {
    "S4": {
      "type": "structure",
      "members": {
        "resourceShareInvitationArn": {},
        "resourceShareName": {},
        "resourceShareArn": {},
        "senderAccountId": {},
        "receiverAccountId": {},
        "invitationTimestamp": {
          "type": "timestamp"
        },
        "status": {},
        "resourceShareAssociations": {
          "shape": "S7"
        }
      }
    },
    "S7": {
      "type": "list",
      "member": {
        "type": "structure",
        "members": {
          "resourceShareArn": {},
          "associatedEntity": {},
          "associationType": {},
          "status": {},
          "statusMessage": {},
          "creationTime": {
            "type": "timestamp"
          },
          "lastUpdatedTime": {
            "type": "timestamp"
          },
          "external": {
            "type": "boolean"
          }
        }
      }
    },
    "Sd": {
      "type": "list",
      "member": {}
    },
    "Se": {
      "type": "list",
      "member": {}
    },
    "Sh": {
      "type": "list",
      "member": {
        "type": "structure",
        "members": {
          "key": {},
          "value": {}
        }
      }
    },
    "Sm": {
      "type": "structure",
      "members": {
        "resourceShareArn": {},
        "name": {},
        "owningAccountId": {},
        "allowExternalPrincipals": {
          "type": "boolean"
        },
        "status": {},
        "statusMessage": {},
        "tags": {
          "shape": "Sh"
        },
        "creationTime": {
          "type": "timestamp"
        },
        "lastUpdatedTime": {
          "type": "timestamp"
        }
      }
    },
    "S10": {
      "type": "list",
      "member": {}
    }
  }
}